module.exports = __webpack_public_path__ + "src/assets/img/close.3e64dc79.svg";